export default "/app/global-wrapper-client/static/221153e302f85f932ff472deec38baea.woff";